import { render } from "./MaggInfoComponent.vue?vue&type=template&id=d803734a"
import script from "./MaggInfoComponent.vue?vue&type=script&lang=js"
export * from "./MaggInfoComponent.vue?vue&type=script&lang=js"

import "./MaggInfoComponent.vue?vue&type=style&index=0&id=d803734a&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__